import { EnabledFulfillmentProvidersProvider } from "@redotech/redo-merchant-fulfillment-app/common/enabled-fulfillment-providers";
import { LiveOmsSettingsProvider } from "@redotech/redo-merchant-fulfillment-app/common/live-oms-settings-context";
import { memo, ReactNode } from "react";
import { Outlet } from "react-router-dom";

/**
 * Wrapper for everything that should be provided to OMS, but that is not necessary elsewhere in the merchant app.
 */
export const OrdersLayoutWrapper = memo(function OrdersLayoutWrapper({
  loadingContent,
}: {
  loadingContent?: ReactNode;
}) {
  return (
    <LiveOmsSettingsProvider>
      <EnabledFulfillmentProvidersProvider loadingContent={loadingContent}>
        <Outlet />
      </EnabledFulfillmentProvidersProvider>
    </LiveOmsSettingsProvider>
  );
});
